import { SET_SCHEMES_RATE } from "../actions/actionMdms";

const initialState = {
  schemesRate: [],
};

const schemeRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SCHEMES_RATE:
      return {
        ...state,
        schemesRate: action.payload,
      };
    default:
      return state;
  }
};

export default schemeRateReducer;
